import Table from "@/app/charts/Table";
import ColumnChart from "@/app/charts/ColumnChart";
import TreemapChart from "@/app/charts/TreemapChart";
import VennChart from "@/app/charts/VennChart";
import UpsetChart from "@/app/charts/UpsetChart";
import SankeyChart from "@/app/charts/SankeyChart";
import WordCloudChart from "@/app/charts/WordCloudChart";
import { getObjectLen } from "@/app/utils/utils";
import ChartSection from "@/app/components/ChartSection";

export function AuthorCharts({
  pubPerYear,
  pubPerArea,
  pubPerAreaInvestigator,
  pubPerOrigin,
  pubPerCoauthors,
  topKeywords,
  overlapingDocuments,
  combinationCounts,
  authorName,
  authorId,
}) {
  return (
    <div className="text-start">
      {getObjectLen(pubPerYear[1]) > 0 && (
        <ChartSection
          title="Volumen de publicaciones por año"
          Chart={<ColumnChart data={pubPerYear[1]} serieName={authorName} />}
          table={pubPerYear}
        />
      )}

      {getObjectLen(pubPerAreaInvestigator[1]) > 0 && (
        <ChartSection
          title="Publicaciones por áreas de conocimiento"
          Chart={<TreemapChart data={pubPerAreaInvestigator[1]} />}
          table={pubPerAreaInvestigator}
        />
      )}

      {getObjectLen(pubPerArea[1]) > 0 && (
        <ChartSection
          title="Publicaciones por áreas temáticas"
          Chart={<TreemapChart data={pubPerArea[1]} />}
          table={pubPerArea}
        />
      )}

      {Object.values(pubPerOrigin[1]).some((value) => value !== 0) && (
        <>
          <ChartSection
            title="Publicaciones por origen"
            Chart={
              <VennChart data={overlapingDocuments} serieName={authorName} />
            }
            table={pubPerOrigin}
          />
          <UpsetChart rawData={combinationCounts} color="#041953" />
        </>
      )}

      {getObjectLen(pubPerCoauthors[1]) > 0 && (
        <ChartSection
          title="Coautores destacados por número de publicaciones"
          Chart={<SankeyChart data={pubPerCoauthors[1]} from={authorName} />}
          table={pubPerCoauthors}
        />
      )}

      {getObjectLen(topKeywords) > 0 && (
        <div className="flex flex-col md:flex-row mt-5 gap-5">
          <div className="w-full shadow-lg p-5">
            <h2 className="text-2xl font-bold text-blue-700">Top Keywords</h2>
            <hr className="border-b border-gray-300 my-4 w-1/6" />
            <WordCloudChart
              data={topKeywords}
              link={`./${authorId}/documents?p=1`}
            />
          </div>
        </div>
      )}
    </div>
  );
}
